
































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapState, mapGetters } from 'vuex';
import { User, MobileGetter, ExperimentGetter } from 'frontend/types';
import PaywallPlanMini from 'frontend/views/premium/components/PaywallPlanMini.vue';
import { safeWindow } from 'frontend/utils/window';
import { subscriptionGiftAddOns } from 'frontend/experiments/subscription_add_ons_06_2022';
import { RawLocation } from 'vue-router';
import { addToCartTrack } from 'frontend/utils/analytics';

@Component({
  components: {
    PaywallPlanMini,
  },
  computed: {
    ...mapGetters('globals', ['inExperiment']),
    ...mapGetters('pageHeader', ['isMobile']),
    ...mapState('globals', ['user']),
    ...mapState('paywall', ['paywall_type']),
  },
})
export default class PaywallPlan extends Vue {
  @Prop(Object) private readonly plan!: any;
  @Prop(Boolean) private readonly upgrade!: boolean | undefined;
  @Prop(Boolean) private readonly onTrialPaywall!: boolean | undefined;
  @Prop(Boolean) private readonly extended!: boolean | undefined;
  @Prop(Boolean) private readonly subpack!: boolean | undefined;

  private user!: User;
  private isMobile!: MobileGetter;
  private inExperiment!: ExperimentGetter;
  // tslint:disable-next-line:variable-name
  private paywall_type!: string;

  private get shouldShowSubpack(): boolean {
    return this.plan.display_name === 'Math plan';
  }

  private get isMobileViewPort(): boolean {
    return this.isMobile(this.$mq);
  }

  private get useExperimentStyling(): boolean {
    return this.onTrialPaywall === true;
  }

  private trackUiEvent(interval: string): string {
    if (this.subpack) {
      return 'clicked_math_subpack';
    }
    return this.axId(interval);
  }

  private axId(interval: string) {
    return `clicked_b2_${interval}_logged_in_chargebee`;
  }

  private get showSuscribebutton(): boolean {
    return (
      this.paywall_type !== 'already_lifetime' &&
      !(this.useExperimentStyling && this.isMobileViewPort)
    );
  }

  private get useMobileStyling(): boolean {
    if (this.isMobileViewPort) {
      return true;
    }

    const w = safeWindow();
    if (w) {
      return w.innerWidth <= 770;
    }

    return false;
  }

  private get inSubscriptionGiftAddOnExperiment(): boolean {
    return subscriptionGiftAddOns(this.inExperiment);
  }

  private giftFormLocation(planType: string): RawLocation {
    return {
      name: 'gift_purchase_message',
      params: { planType },
    };
  }

  private handleSubscribeNowClick(checkoutUrl: Location) {
    if (!this.user.is_authenticated) {
      this.$store.dispatch('signupModal/signup');
    } else if (this.subpack) {
      addToCartTrack();
      this.$emit('subpack-button-clicked');
    } else {
      addToCartTrack();
      if (this.inSubscriptionGiftAddOnExperiment) {
        const location = this.giftFormLocation('annual');
        this.$router.push(location);
      } else {
        const win = safeWindow();
        if (win) {
          (win as any).location = checkoutUrl;
        }
      }
    }
  }
}
